'use client';

import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import * as React from 'react';

import { cn } from '../../lib/cn';

/** Contesto condiviso (delay, ecc.) per tutti i {@link Tooltip} discendenti; va montato una volta in alto nell'albero. */
const TooltipProvider = TooltipPrimitive.Provider;

/** Radice di un singolo tooltip: gestisce apertura/chiusura al passaggio del mouse/focus. */
const Tooltip = TooltipPrimitive.Root;

/** Elemento che mostra il tooltip al passaggio del mouse/focus. */
const TooltipTrigger = TooltipPrimitive.Trigger;

/** Props di {@link TooltipContent}: eredita gli attributi standard di Radix (`sideOffset`, ecc.). */
export interface TooltipContentProps extends React.ComponentPropsWithoutRef<
	typeof TooltipPrimitive.Content
> {}

/** Fumetto con il testo del tooltip. */
const TooltipContent = React.forwardRef<
	React.ElementRef<typeof TooltipPrimitive.Content>,
	TooltipContentProps
>(({ className, sideOffset = 4, ...props }, ref) => (
	<TooltipPrimitive.Content
		ref={ref}
		sideOffset={sideOffset}
		className={cn(
			'z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-tooltip-content-transform-origin]',
			className,
		)}
		{...props}
	/>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
